export class DisplayScoreProgress extends Phaser.GameObjects.Container {
  constructor(scene, data) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this._data = data;
    this._type = data.type.replace('update_', '');

    this._progress = this._data.score / 100;

    this.width = 300;
    this.height = 96;

    this.setupBaseScoreProgress();
  }

  setupBaseScoreProgress() {
    this.text = this.scene.add.sprite(0, 0, 'scores', `score_${this._type}_text`).setOrigin(0.5, 0);
    this.bar = this.scene.add.sprite(0, 0, 'scores', 'score_bar').setOrigin(0.5, 0);
    this.bar.y = this.text.y + this.text.height;

    this.icon = this.scene.add
      .sprite(-(this.bar.width / 2 - 22), this.bar.y + 15, 'scores', `score_${this._type}_icon`)
      .setOrigin(0, 0);

    this.leftCap = this.scene.add
      .sprite(-(this.bar.width / 2), this.bar.y, 'scores', `score_${this._type}_cap_left`)
      .setOrigin(0, 0);

    this.leftCap.alpha = this._progress > 0 ? 1 : 0;

    this.rightCap = this.scene.add
      .sprite(this.bar.width / 2, this.bar.y, 'scores', `score_${this._type}_cap_right`)
      .setOrigin(1, 0);

    this.rightCap.alpha = this._progress === 1 ? 1 : 0;

    this.barFill = this.scene.add
      .sprite(
        -(this.bar.width / 2 - this.leftCap.width),
        this.bar.y,
        'scores',
        `score_${this._type}_fill`
      )
      .setOrigin(0);
    this.barFill.displayWidth = this.barFill.width * this._progress;
    this.add([this.text, this.bar, this.leftCap, this.rightCap, this.barFill, this.icon]);
  }

  shutdown() {
    this.timeline.destroy();
    this.destroy();
  }
}
